import { ReactNode } from 'react'

import { notNullOrUndefinedFilter } from '@avantstay/backoffice-core'

import { ViewModeTypes } from './ViewMode.types'

interface ViewModeOption {
  label: string
  labelComponent?: ReactNode
  value: ViewModeTypes
}

interface GetDistributionSubOptionsParams {
  hasDistributionPermission?: boolean
}

const DISTRIBUTION_VIEW_MODES = new Set([
  ViewModeTypes.DISTRIBUTION_CONNECTIONS,
  ViewModeTypes.DISTRIBUTION_LISTING_STATUS,
])

export const isDistributionViewMode = (viewMode: ViewModeTypes) =>
  DISTRIBUTION_VIEW_MODES.has(viewMode)

export const viewModeOptions: ViewModeOption[] = [
  { label: 'Finance', value: ViewModeTypes.FINANCE },
  { label: 'Occupancy', value: ViewModeTypes.OCCUPANCY },
  {
    label: 'Website Configuration',
    value: ViewModeTypes.CONFIGURATION_STATUS,
  },
  {
    label: 'Airbnb Trip Issues',
    value: ViewModeTypes.AIRBNB_TRIP_ISSUES,
  },
  {
    label: 'Distribution',
    value: ViewModeTypes.DISTRIBUTION_LISTING_STATUS,
  },
  { label: 'Performance', value: ViewModeTypes.PERFORMANCE },
  {
    label: 'Asset Performance',
    value: ViewModeTypes.ASSETS_PERFORMANCE_DASHBOARD,
  },
  {
    label: 'Locations',
    value: ViewModeTypes.LOCATIONS,
  },
  {
    label: 'Revenue Configuration',
    value: ViewModeTypes.REVENUE_CONFIGURATION,
  },
  {
    label: 'Vendor Rates',
    value: ViewModeTypes.VENDOR_RATES,
  },
  {
    label: 'Bulk Edit',
    value: ViewModeTypes.BULK_EDIT,
  },
  {
    label: 'Collections',
    value: ViewModeTypes.COLLECTIONS,
  },
]

export const getDistributionSubOptions = ({
  hasDistributionPermission = false,
}: GetDistributionSubOptionsParams = {}): ViewModeOption[] =>
  [
    {
      label: 'Listing Status',
      value: ViewModeTypes.DISTRIBUTION_LISTING_STATUS,
    },
    hasDistributionPermission
      ? {
          label: 'Connections',
          value: ViewModeTypes.DISTRIBUTION_CONNECTIONS,
        }
      : null,
  ].filter(notNullOrUndefinedFilter)
